import React from 'react';
import {
  Box,
  Heading,
  Text,
  UnorderedList,
  ListItem,
  Divider,
} from '@chakra-ui/react';

const ReturnPolicy = () => {
  return (
    <Box maxW="960px" mx="auto" px={4} py={8}>
      <Heading as="h1" size="xl" mb={6}>
        Política de Devoluciones y Derecho de Arrepentimiento
      </Heading>

      <Text mb={4}>
        En <strong>Gestar Educativa</strong>, priorizamos la transparencia y la confianza de nuestros estudiantes. Por eso, nuestra política de devoluciones cumple con lo establecido en la Ley de Defensa del Consumidor (Ley 24.240) y garantiza condiciones claras para ejercer el derecho de arrepentimiento.
      </Text>

      <Divider my={6} />
      <Heading as="h2" size="lg" mb={3}>
        1. Derecho de arrepentimiento (compras online)
      </Heading>
      <Text mb={2}>
        De acuerdo con el artículo 34 de la Ley 24.240, si realizás la inscripción o compra de un curso a través de medios digitales (web, redes, WhatsApp u otros canales no presenciales), tenés derecho a desistir de la operación dentro de los 10 días corridos desde:
      </Text>
      <UnorderedList spacing={2} mb={2}>
        <ListItem>La fecha de adquisición del curso, o</ListItem>
        <ListItem>La fecha de acceso al contenido/aula virtual, lo que ocurra último.</ListItem>
      </UnorderedList>
      <Text mb={2}>
        Durante ese plazo, podés solicitar el reembolso total del dinero abonado, sin necesidad de expresar causa, siempre que:
      </Text>
      <UnorderedList spacing={2} mb={6}>
        <ListItem>No hayas completado más del 25% del curso (para cursos asincrónicos).</ListItem>
        <ListItem>No hayas asistido a más de una clase en vivo (para cursos sincrónicos).</ListItem>
        <ListItem>No hayas descargado certificados.</ListItem>
      </UnorderedList>

      <Divider my={6} />
      <Heading as="h2" size="lg" mb={3}>
        2. Procedimiento para solicitar la devolución
      </Heading>
      <Text mb={2}>
        Para ejercer tu derecho de arrepentimiento, deberás enviar un correo a <strong>atencion.estudiantes@gestareducativa.com.ar</strong> con el asunto "Solicitud de Devolución", indicando:
      </Text>
      <UnorderedList spacing={2} mb={2}>
        <ListItem>Nombre completo.</ListItem>
        <ListItem>Nombre del curso.</ListItem>
        <ListItem>Fecha de inscripción.</ListItem>
        <ListItem>Medio por el cual realizaste la compra.</ListItem>
      </UnorderedList>
      <Text mb={6}>
        La devolución se realizará por el mismo medio de pago utilizado dentro de los 10 días hábiles desde la solicitud.
      </Text>

      <Divider my={6} />
      <Heading as="h2" size="lg" mb={3}>
        3. Excepciones
      </Heading>
      <Text mb={2}>No se aceptarán devoluciones cuando:</Text>
      <UnorderedList spacing={2} mb={6}>
        <ListItem>El curso haya finalizado.</ListItem>
        <ListItem>El usuario haya accedido y utilizado más del 25% del contenido asincrónico.</ListItem>
        <ListItem>El curso sea personalizado o hecho a medida (por ejemplo, capacitaciones empresariales).</ListItem>
        <ListItem>El estudiante haya asistido a más de una clase en vivo.</ListItem>
        <ListItem>Se trate de promociones especiales que indiquen expresamente que no admiten reembolso.</ListItem>
      </UnorderedList>

      <Divider my={6} />
      <Heading as="h2" size="lg" mb={3}>
        4. Cancelaciones fuera del plazo de arrepentimiento
      </Heading>
      <Text>
        Luego del plazo legal, se podrá evaluar la cancelación del curso en casos excepcionales, a pedido del estudiante, aplicando un crédito a favor para ser utilizado en futuros cursos.
      </Text>
    </Box>
  );
};

export default ReturnPolicy;
